import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/painel",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/painel",
          name: "painel",
          component: () => import("@/view/pages/Painel.vue")
        },
        {
          path: "/perfil",
          name: "perfil",
          component: () => import("@/view/pages/Perfil.vue")
        },
        {
          path: "/validacao",
          name: "validacao",
          component: () => import("@/view/pages/validation/list.vue")
        },
        {
          path: "/dadospessoais",
          name: "dadosPessoais",
          component: () => import("@/view/pages/personalData/add.vue")
        },
        {
          path: "/dadosfuncionais",
          name: "dadosFuncionais",
          component: () => import("@/view/pages/functionalData/add.vue")
        },
        {
          path: "/documentospessoais",
          name: "documentosPessoais",
          component: () => import("@/view/pages/personalDocuments/index.vue"),
          children: [
            {
              path: "/documentospessoais/novo",
              name: "documentosPessoaisNovo",
              component: () => import("@/view/pages/personalDocuments/edit.vue")
            }
          ]
        },
        {
          path: "/formacao",
          name: "formacao",
          component: () => import("@/view/pages/degree/add.vue")
        },
        {
          path: "/dependentes",
          name: "dependentes",
          component: () => import("@/view/pages/dependent/list.vue")
        },
        {
          path: "/residencia",
          name: "residencia",
          component: () => import("@/view/pages/residence/add.vue")
        },
        {
          path: "/contato",
          name: "contato",
          component: () => import("@/view/pages/contact/add.vue")
        },
        {
          path: "/protocolo",
          name: "protocolo",
          component: () => import("@/view/pages/protocol/add.vue")
        },
        {
          path: "/envioarquivos",
          name: "envioarquivos",
          component: () => import("@/view/pages/filesend/index.vue")
        },
        {
          path: "validacao/:id",
          name: "validacao_cadastro",
          component: () => import("@/view/pages/validation/index.vue")
        },
        {
          path: "visualizacao",
          name: "visualizacao_cadastro_usuario",
          component: () =>
            import("@/view/pages/visualization/visualization.vue")
        },
        {
          path: "visualizacao/:id",
          name: "visualizacao_cadastro",
          component: () =>
            import("@/view/pages/visualization/visualization.vue")
        },
        {
          path: "/liberacao",
          name: "liberacao",
          component: () => import("@/view/pages/release/list.vue")
        },
        {
          path: "/legislacoes",
          name: "legislacoes",
          component: () => import("@/view/pages/legislations/list.vue")
        },
        {
          path: "/recadastramentos/ano/:registrationYear",
          name: "recadastramentos",
          component: () => import("@/view/pages/reRegistrations/listFilter.vue")
        },
        {
          path: "/recadastramentos/gestores",
          name: "recadastramentosGestores",
          component: () => import("@/view/pages/reRegistrations/listUsers.vue")
        },
        {
          path: "/recadastramentos/listar/:mes",
          name: "recadastramentosListagem",
          component: () =>
            import("@/view/pages/reRegistrations/listemployees.vue")
        },
        {
          path: "/relatorios/geral",
          name: "geral",
          component: () => import("@/view/pages/report/generalReport.vue")
        },
        {
          path: "/relatorios/troca-lotacao",
          name: "lotationChange",
          component: () => import("@/view/pages/report/lotationChange.vue")
        },
        {
          path: "/relatorios/sinalizacao-deficiencia",
          name: "FormationDisabledSignage",
          component: () => import("@/view/pages/report/FormationDisabledSignage.vue")
        },
        {
          path: "/relatorios/area-de-formacao",
          name: "FormationAreaReport",
          component: () => import("@/view/pages/report/FormationAreaReport.vue")
        },
        {
          path: "/relatorios/grau-de-instrucao",
          name: "grauInstrucao",
          component: () => import("@/view/pages/report/grauInstrucao.vue")
        },
        {
          path: "/relatorios/informacoes-eleitorais",
          name: "infomacoesEleitorais",
          component: () =>
            import("@/view/pages/report/informacoesEleitorais.vue")
        },
        {
          path: "/relatorios/envio",
          name: "envio",
          component: () => import("@/view/pages/report/envio.vue")
        },
        {
          path: "/relatorios/lista-servidores",
          name: "AllEmployees",
          component: () => import("@/view/pages/report/AllEmployees.vue")
        },
        {
          path: "/relatorios/reenvio-correcao",
          name: "reenvio",
          component: () => import("@/view/pages/report/reenvio.vue")
        },
        {
          path: "/cadastroDAF",
          name: "cadastroDAF",
          component: () => import("@/view/pages/manager/listdaf.vue")
        },
        {
          path: "/cadastroCEPs",
          name: "cadastroCEPs",
          component: () => import("@/view/pages/admin/cepRegistration.vue")
        },
        {
          path: "/cadastroGestor",
          name: "cadastroGestor",
          component: () => import("@/view/pages/manager/list.vue")
        },
        {
          path: "/liberacao/listar/:mes",
          name: "liberacao listagem",
          component: () => import("@/view/pages/release/listemployees.vue")
        },
        {
          path: "/relatorios",
          name: "relatorios",
          component: () => import("@/view/pages/report/list.vue")
        },
        {
          path: "/cadastroUsuarios",
          name: "cadastroUsuarios",
          component: () => import("@/view/pages/user/list.vue")
        },
        {
          path: "/integracao",
          name: "consultaEturmalina",
          component: () => import("@/view/pages/integration/list.vue")
        },
        {
          path: "/integracaoDados",
          name: "Integração de dados",
          component: () => import("@/view/pages/integracaoDados/Index.vue"),
          children: [
            {
              path: "/integracaoDados",
              name: "integrationIndex",
              component: () => import("@/view/pages/integracaoDados/Table.vue")
            }
          ]
        },
        {
          path: "/logs",
          name: "logs",
          component: () => import("@/view/pages/logs/list.vue")
        }
      ]
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/auth/Auth"),
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/auth/Login")
        },
        {
          name: "verify",
          path: "verify/:token",
          component: () => import("@/view/pages/auth/Verify")
        },
        {
          name: "update",
          path: "/update/:token",
          component: () => import("@/view/pages/auth/UpdatePassword")
        },
        {
          name: "confirm",
          path: "/confirm",
          component: () => import("@/view/pages/auth/ConfirmData")
        },
        {
          name: "recover_password",
          path: "/esqueceu_senha",
          component: () => import("@/view/pages/auth/RecoverPassword")
        }
      ]
    },
    {
      path: "/403",
      name: "403",
      component: () => import("@/view/pages/Painel.vue")
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // rota 404, quando nenhuma nao acessa nenhuma rota configurada acima
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
